import React from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import { Button } from '@mui/material';
import { SlideTransition } from '../Transition/Transition';

export default function RecruitmentHelpModal(props) {
  const { open, onClose, intl } = props;

  return (
    <Dialog open={open} onClose={onClose} slots={{
      transition: SlideTransition
    }}>
      <DialogTitle>{intl.formatMessage({ id: 'recruitment-help-title' })}</DialogTitle>
      <DialogContent>{intl.formatMessage({ id: 'recruitment-help-content' })}</DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          {intl.formatMessage({ id: 'OK' })}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
